const STORAGE_PREFIX = "sample_refresh_cooldown_"

export const SAMPLE_REFRESH_COOLDOWN_MS = 10 * 60 * 1000

const getStorageKey = (submissionId: string) => `${STORAGE_PREFIX}${submissionId}`

export const getSampleRefreshCooldownExpiresAt = (submissionId: string) => {
  const raw = localStorage.getItem(getStorageKey(submissionId))
  return raw ? Number(raw) : null
}

export const clearSampleRefreshCooldown = (submissionId: string) => {
  localStorage.removeItem(getStorageKey(submissionId))
}

export const isSampleRefreshOnCooldown = (submissionId: string) => {
  const expiresAt = getSampleRefreshCooldownExpiresAt(submissionId)
  if (!expiresAt) return false

  if (Date.now() >= expiresAt) {
    clearSampleRefreshCooldown(submissionId)
    return false
  }

  return true
}

export const setSampleRefreshCooldown = (submissionId: string) => {
  localStorage.setItem(getStorageKey(submissionId), String(Date.now() + SAMPLE_REFRESH_COOLDOWN_MS))
}

export const getSampleRefreshCooldownRemainingMs = (submissionId: string) => {
  const expiresAt = getSampleRefreshCooldownExpiresAt(submissionId)
  if (!expiresAt) return 0
  return Math.max(0, expiresAt - Date.now())
}

export const formatSampleRefreshCooldownRemaining = (remainingMs: number) => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  if (minutes > 0 && seconds > 0) {
    return `${minutes} phút ${seconds} giây`
  }
  if (minutes > 0) {
    return `${minutes} phút`
  }
  return `${seconds} giây`
}

export const getSampleRefreshCooldownMessage = (submissionId: string) => {
  const remainingMs = getSampleRefreshCooldownRemainingMs(submissionId)
  return `Có thể làm mới sau ${formatSampleRefreshCooldownRemaining(remainingMs)}`
}
